import { render, staticRenderFns } from "./CartSubmittedCard.vue?vue&type=template&id=56b1342c&scoped=true&"
import script from "./CartSubmittedCard.vue?vue&type=script&lang=js&"
export * from "./CartSubmittedCard.vue?vue&type=script&lang=js&"
import style0 from "./CartSubmittedCard.vue?vue&type=style&index=0&id=56b1342c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b1342c",
  null
  
)

export default component.exports